import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import {
  CameraAlt as CameraAltIcon
} from '@mui/icons-material';

const PhotoUploadDialog = ({ 
  open,
  selectedFile,
  uploadingPhoto,
  onClose,
  onUpload
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <CameraAltIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
        <Typography variant="h6">Nouvelle photo</Typography>
      </DialogTitle>
      <DialogContent>
        {selectedFile && (
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <img
              src={URL.createObjectURL(selectedFile)}
              alt="Aperçu"
              style={{ 
                width: '100%', 
                maxHeight: 200, 
                objectFit: 'cover',
                borderRadius: 8
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {selectedFile.name} • {(selectedFile.size / 1024 / 1024).toFixed(1)} MB
            </Typography>
          </Box>
        )}
        {uploadingPhoto && (
          <Box sx={{ mb: 2 }}>
            <LinearProgress />
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 1 }}>
              Ajout en cours...
            </Typography>
          </Box>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          Cette photo sera ajoutée à votre galerie et visible par vos clients.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} disabled={uploadingPhoto} fullWidth>
          Annuler
        </Button>
        <Button onClick={onUpload} variant="contained" disabled={uploadingPhoto} fullWidth>
          {uploadingPhoto ? 'Ajout...' : 'Ajouter'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhotoUploadDialog;